import React, { useEffect, useState } from "react";
import OtherPageHeader from "../../../../components/OtherHeader";
import AxiosInstance from "../../../../AxiosInstance";
import { amountFormat } from "../../../../utils";
import { Table, DatePicker, Button } from "antd";
import styles from "../partnerDashboard.module.css";
import moment from "moment";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;

export default function PartnerEarnings() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(30, "days"),
    dayjs(),
  ]); // Default last 30 days range

  useEffect(() => {
    getTableData(0, dateRange);
    getSummaryData();
  }, []);

  // Function to get table data with fromDate and toDate
  const getTableData = async (skip, dateRange) => {
    const [fromDate, toDate] = dateRange;
    const url = `/crm/incentive/list?take=10&skip=${skip}&source=INVESTMENT&fromDate=${fromDate?.format(
      "YYYY-MM-DD"
    )}&toDate=${toDate?.format("YYYY-MM-DD")}`;

    setLoading(true);
    AxiosInstance()
      .get(url)
      .then((resp) => {
        const { data } = resp;
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Function to get summary data
  const getSummaryData = async () => {
    const [fromDate, toDate] = dateRange;

    const url = `/partner/summary?fromDate=${fromDate?.format(
      "YYYY-MM-DD"
    )}&toDate=${toDate?.format("YYYY-MM-DD")}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setSummaryData(data);
      })
      .catch((err) => {});
  };

  // Handle pagination change
  const handlePageChange = (page) => {
    getTableData((page - 1) * 10, dateRange);
  };

  // Handle date range change
  const handleDateChange = (dates) => {
    console.log(dates);
    setDateRange(dates);
  };

  // Apply filter based on selected date range
  const applyDateFilter = () => {
    getTableData(0, dateRange);
    getSummaryData();
  };

  const columns = [
    // { title: "Serial No", key: "serialNo", align: "center" },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "center",
    },
    {
      title: "Investor Name",
      key: "investorName",
      align: "center",
      render: (text, data) => (
        <>{data.investor?.firstName + " " + data.investor?.lastName}</>
      ),
    },
    {
      title: "Total Investment",
      dataIndex: "investmentAmount",
      key: "investmentAmount",
      align: "center",
      render: (text) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Commission",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      render: (text) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Investment Date",
      dataIndex: "assignmentStartDate",
      key: "assignmentStartDate",
      align: "center",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
  ];
  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const getFinancialYearRanges = () => {
    const today = dayjs();
    const currentYear = today.year();
    const currentMonth = today.month();

    const currentFYStart =
      currentMonth >= 3
        ? dayjs(`${currentYear}-04-01`)
        : dayjs(`${currentYear - 1}-04-01`);
    const currentFYEnd =
      currentMonth >= 3
        ? dayjs(`${currentYear + 1}-03-31`)
        : dayjs(`${currentYear}-03-31`);

    const lastFYStart = currentFYStart.subtract(1, "year");
    const lastFYEnd = currentFYEnd.subtract(1, "year");

    const twoFYAgoStart = currentFYStart.subtract(2, "year");
    const twoFYAgoEnd = currentFYEnd.subtract(2, "year");

    return [
      {
        label: `FY ${lastFYStart.year()}-${lastFYEnd.year()}`,
        value: [lastFYStart, lastFYEnd],
      },
      {
        label: `FY ${twoFYAgoStart.year()}-${twoFYAgoEnd.year()}`,
        value: [twoFYAgoStart, twoFYAgoEnd],
      },
    ];
  };

  const rangePresets = [
    { label: "Last 7 Days", value: [dayjs().subtract(7, "d"), dayjs()] },
    {
      label: "Month Till Date",
      value: [dayjs().startOf("month"), dayjs()],
    },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "d"), dayjs()] },
    {
      label: "Last Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    { label: "Last 3 Months", value: [dayjs().subtract(3, "month"), dayjs()] },

    ...getFinancialYearRanges(),
  ];

  return (
    <section className="tre_bg-gray position-relative">
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />

      <div className="container bg-market">
        {/* Date Range Picker */}
        {/* <div className="overflow-hide  d-flex justify-content-center ">
          <h2>My Earnings</h2>
        </div> */}
        <button
          type="submit"
          title="back-button"
          className="back-button mb-2"
          onClick={() => navigate(-1)}
        >
          {" "}
          <i className="fa fa-angle-left" /> <b>Back</b>
        </button>
        <div className="d-flex justify-content-start mb-3 gap-3">
          <RangePicker
            presets={[
              // {
              //   label: (
              //     <span aria-label="Current Time to End of Day">Now ~ EOD</span>
              //   ),
              //   value: () => [dayjs(), dayjs().endOf("day")], // 5.8.0+ support function
              // },
              ...rangePresets,
            ]}
            value={dateRange}
            onChange={handleDateChange}
            allowClear={false}
            format="DD/MM/YYYY"
            className=""
            disabledDate={disableFutureDates} // Disable future dates
          />
          <Button type="primary" onClick={applyDateFilter}>
            Apply
          </Button>
        </div>
        <div className="d-flex justify-content-center">
          <div
            className={`ph-summary  h-[200px] p-4 shadow ${styles["partner-summary-card"]} pt-2`}
          >
            <div className="d-flex justify-content-center">
              {" "}
              <h5>
                <b>My Earnings</b>
              </h5>
            </div>
            <div className="row">
              {" "}
              <div className="col">
                Total Incentive: {amountFormat(summaryData?.amount)}
              </div>
              <div className="col">
                Investment Amount: {amountFormat(summaryData?.investmentAmount)}
              </div>
            </div>
            <div className="row mt-2">
              {" "}
              <div className="col">
                No. of Policies: {amountFormat(summaryData?.countAssignment)}
              </div>
              {/* <div className="col">
                Total Fund Value:{" "}
                {amountFormat(summaryData?.totalCurrentSurrenderValue)}
              </div> */}
            </div>
            {/* <div className="d-flex justify-content-center mt-2">
              Total Investments:{" "}
              {amountFormat(summaryData?.totalInvestmentAmount)}
            </div> */}
          </div>
        </div>
        {/* Table */}
        <div className="policies-table">
          <Table
            bordered
            scroll={{ x: 400 }}
            loading={loading}
            className="table"
            dataSource={dataSource}
            columns={columns}
            pagination={{
              pageSize: 10,
              total: paginationMetaData.count,
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </section>
  );
}
